import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { ServiceGrid } from './components/ServiceGrid';
import { Portfolio } from './components/Portfolio';
import { Process } from './components/Process';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ServiceArea } from './components/ServiceArea';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-white font-body text-brand-black selection:bg-brand-red selection:text-white pb-16 md:pb-0" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <TrustBar data-id="element-5" />
          <ServiceGrid data-id="element-6" />
          <Portfolio data-id="element-7" />
          <Process data-id="element-8" />
          <WhyChooseUs data-id="element-9" />
          <Testimonials data-id="element-10" />
          <FAQ data-id="element-11" />
          <ServiceArea data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <FloatingCTA data-id="element-14" />
      </div>
    </LanguageProvider>;
}